template = require('./progress_labels.html.slim')

angular.module('wbComponents').directive 'wbProgressLabels',
[  ->
  restrict: 'E'
  replace: true
  scope:
    categories: "="
    step: "="

  templateUrl: template

  link: ($scope, $el, $attrs) ->

    $scope.isActive = (category) ->
      $scope.step >= category.min && $scope.step <= category.max

    $scope.isComplete = (category) ->
      $scope.step > category.max

    $scope.isInProgress = (category) ->
      $scope.step > category.min && $scope.step <= category.max

    $scope.stepProgress = (category) ->
      if $scope.isActive(category)
        totalSteps = category.max - ( Math.max( category.min - 1, 0 ) )
        percentageComplete = ( ( $scope.step - category.min ) / totalSteps )*100
        {"width": "#{percentageComplete}%"} unless percentageComplete < 1
      else if $scope.isComplete(category)
        {"width": "100%", "border-radius": "2px"}
      else
        {"width": "0"}
]
